export default __webpack_public_path__ + "assets/d7f9b65c17d354eef63ba22717993170.woff";